import React, { useEffect, useState } from "react";
import Modal from "../../../../parts/modal-new";
import Dropdown from "../../../../parts/dropdown";
import SvgIcon from "../../../../parts/SvgIcon";
import { useTranslation } from "react-i18next";

const RPE_VALUES = [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];
const numberReg = /-?(\d+(\.\d*)?)?/;
const notNumberReg = /[^-\.0-9]/g;

const FilterExercisesModal = ({ filters, activeUser, onFiltersSubmit }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const [showModal, setShowModal] = useState(false);
  const allLabel = t("athlete-portal:filterExercisesModal.all");
  const [state, setState] = useState({
    repsFrom: filters.repsFrom || "All",
    repsTo: filters.repsTo || "All",
    rpeFrom: filters.rpeFrom || "All",
    rpeTo: filters.rpeTo || "All",
    loadFrom: filters.loadFrom || "",
    loadTo: filters.loadTo || "",
  });
  useEffect(() => {
    setState({
      repsFrom: filters.repsFrom || "All",
      repsTo: filters.repsTo || "All",
      rpeFrom: filters.rpeFrom || "All",
      rpeTo: filters.rpeTo || "All",
      loadFrom: filters.loadFrom || "",
      loadTo: filters.loadTo || "",
    });
  }, [filters]);
  const { units } = activeUser;
  const handleInputChange = ({ name, value }) => {
    if (
      (name === "loadFrom" || name === "loadTo") &&
      value !== "" &&
      value != null
    ) {
      const val = value.replace(notNumberReg, "");
      const match = (val.match(numberReg) || [])[0];
      if (value !== match) value = match;
    }

    setState({
      ...state,
      [name]: value,
    });
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const { repsFrom, repsTo, rpeFrom, rpeTo, loadFrom, loadTo, sortOrder } =
      state;

    setShowModal(false);

    onFiltersSubmit({
      repsFrom,
      repsTo,
      rpeFrom,
      rpeTo,
      loadFrom,
      loadTo,
      sortOrder,
    });
  };
  return (
    <>
      {!showModal && (
        <button
          data-button-type="secondary"
          data-icon
          onClick={() => setShowModal(true)}
        >
          <SvgIcon src="/img/new-icons/filter-white.svg" />
          {t("common:filter")}
        </button>
      )}
      {showModal && (
        <Modal
          title={t("filterExercisesModal.title")}
          onClose={() => setShowModal(false)}
          className={"filter-exercises"}
        >
          <div className="body">
            <form id="exercise-filters" onSubmit={handleFormSubmit}>
              <section>
                <div>
                  <label></label>
                  <label>{t("filterExercisesModal.from")}</label>
                  <label>{t("filterExercisesModal.to")} </label>
                </div>
                <div>
                  <label>{t("filterExercisesModal.repsNumber")}</label>

                  <Dropdown
                    summaryText={
                      state.repsFrom === "All" ? allLabel : state.repsFrom
                    }
                    options={Array.from({ length: 25 }, (y, i) => ({
                      text: i + 1,
                      value: i + 1,
                    }))}
                    onSelectFn={(value) =>
                      handleInputChange({ name: "repsFrom", value })
                    }
                  />
                  <Dropdown
                    summaryText={
                      state.repsTo === "All" ? allLabel : state.repsTo
                    }
                    options={Array.from({ length: 25 }, (y, i) => ({
                      text: i + 1,
                      value: i + 1,
                    }))}
                    onSelectFn={(value) =>
                      handleInputChange({ name: "repsTo", value })
                    }
                  />
                </div>
              </section>
              <section>
                <div>
                  <label></label>
                  <label>{t("filterExercisesModal.from")}</label>
                  <label>{t("filterExercisesModal.to")} </label>
                </div>
                <div>
                  <label>{t("filterExercisesModal.rpeNumber")}</label>
                  <Dropdown
                    summaryText={
                      state.rpeFrom === "All" ? allLabel : state.rpeFrom
                    }
                    options={RPE_VALUES.map((value) => ({
                      text: value,
                      value,
                    }))}
                    onSelectFn={(value) =>
                      handleInputChange({ name: "rpeFrom", value })
                    }
                  />
                  <Dropdown
                    summaryText={
                      state.rpeTo === "All" ? allLabel : state.rpeTo
                    }
                    options={RPE_VALUES.map((value) => ({
                      text: value,
                      value,
                    }))}
                    onSelectFn={(value) =>
                      handleInputChange({ name: "rpeTo", value })
                    }
                  />
                </div>
              </section>
              <section>
                <div>
                  <label></label>
                  <label>{t("filterExercisesModal.from")}</label>
                  <label>{t("filterExercisesModal.to")} </label>
                </div>
                <div>
                  <label>{t("filterExercisesModal.load")}</label>
                  <div>
                    <input
                      name="loadFrom"
                      type="number"
                      inputMode="numeric"
                      pattern="-?\d+(\.\d+)?"
                      step=".01"
                      min={0}
                      value={state.loadFrom}
                      onChange={(e) => handleInputChange(e.target)}
                    />
                    <span className="units">
                      {units === "metric" ? "KG" : "LB"}
                    </span>
                  </div>
                  <div>
                    <input
                      name="loadTo"
                      type="number"
                      inputMode="numeric"
                      pattern="-?\d+(\.\d+)?"
                      step=".01"
                      min={0}
                      value={state.loadTo}
                      onChange={(e) => handleInputChange(e.target)}
                    />
                    <span className="units">
                      {units === "metric" ? "KG" : "LB"}
                    </span>
                  </div>
                </div>
              </section>
            </form>
          </div>
          <footer>
            <button
              type="submit"
              form="exercise-filters"
              data-button-type="primary"
            >
              {t("filterExercisesModal.filter")}
            </button>
          </footer>
        </Modal>
      )}
    </>
  );
};

export default FilterExercisesModal;
